/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Registration } from './components/Registration'
import { ForgotPassword } from './components/ForgotPassword'
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { ToastContainer } from 'react-toastify'
import { Player } from '@lottiefiles/react-lottie-player';
import animationData from '../../../Assets/Animation_1748495041004.json';

export function AuthPage() {
  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div>
      <ToastContainer />
      <div className="d-flex min-vh-100 position-relative overflow-hidden">
        {/* Left Side - Clean Branding matching dashboard */}
        <div
          className="d-none d-md-flex flex-column justify-content-center align-items-center text-white p-5 position-relative"
          style={{
            width: '50%',
            background: 'linear-gradient(135deg, #B91C1C 0%,rgb(214, 88, 88) 100%)',
            overflow: 'hidden'
          }}
        >
          {/* Clean grid pattern */}
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                  <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="0.5" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#grid)" />
            </svg>
          </div>

          <div className="text-center z-index-1 position-relative mb-5" style={{ top: '100px' }}>
            <h1 className="display-4 fw-bold text-white mb-3" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
              Welcome to Causeway Logistics
            </h1>
            <p className="lead text-white text-center px-4 opacity-90 mb-4">
              Driving supply chain efficiency through smart, scalable logistics solutions.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <div className="bg-white bg-opacity-15 rounded-pill px-3 py-1">
                <small className="text-white fw-semibold">Integrated</small>
              </div>
              <div className="bg-white bg-opacity-15 rounded-pill px-3 py-1">
                <small className="text-white fw-semibold">Scalable</small>
              </div>
              <div className="bg-white bg-opacity-15 rounded-pill px-3 py-1">
                <small className="text-white fw-semibold">Reliable</small>
              </div>
            </div>
          </div>


          <div className="position-relative z-index-1 w-100">
            <Player
              autoplay
              loop
              src={animationData}
              style={{ height: 'auto', width: '100%', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))' }}
            />
          </div>
        </div>

        {/* Right Side - Clean matching dashboard colors */}
        <div
          className="d-flex flex-column justify-content-center align-items-center w-100 w-md-50 p-5 position-relative"
          style={{
            background: '#F8F9FA',
          }}
        >
          {/* Login Box */}
          <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
            {/* begin::Logo */}
            <a href='#' className='mb-8'>
              <h1 className='logo' style={{ color: '#1F2937' }}>Ca<span className='center-text' style={{ color: '#B91C1C' }}>use</span>way</h1>
            </a>
            {/* end::Logo */}

            {/* begin::Wrapper */}
            <div
              className='w-lg-500px rounded-4 shadow-sm p-2 p-md-6 p-lg-10 mx-auto position-relative'
              style={{
                background: '#FFFFFF',
                border: '1px solid #E2E8F0',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.08)'
              }}
            >
              {/* Top accent border */}
              <div
                className="position-absolute"
                style={{
                  top: '0',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '80px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #E53E3E, #C53030)',
                  borderRadius: '0 0 4px 4px'
                }}
              ></div>

              <Switch>
                <Route path='/auth/login' component={Login} />
                <Redirect from='/auth' exact={true} to='/auth/login' />
                <Redirect to='/auth/login' />
              </Switch>
            </div>
            {/* end::Wrapper */}
          </div>
        </div>
      </div>

    </div>
  )
}
